<template>
    <div class="wrapper">
        <div class="help-tools">
            <div class="help-column">
                <p>Useful tools</p>
                <div class="help-cards">
                    <a href="https://help.afrihost.com/topic/fixed-wireless-internet" class="help-card large">
                        <dl>
                            <dt>Frequently asked questions</dt>
                            <dd>Get answers to your frequently asked Fixed LTE questions.</dd>
                        </dl>
                        <svg class="arrow"><use xlink:href="#arrow"></use></svg>
                    </a>
                </div><!-- end.help-cards -->
            </div><!-- end.help-column -->
            <div class="help-column">
                <p>Support Platforms</p>
                <div class="help-cards">
                    <a href="https://whatsapp.afrihost.com/" class="help-card">
                        <svg class="icon"><use xlink:href="#whatsapp"></use></svg>
                        <p>WhatsApp Help</p>
                    </a>
                    <a href="https://help.afrihost.com/" class="help-card">
                        <svg class="icon"><use xlink:href="#help"></use></svg>
                        <p>Help Centre</p>
                    </a>
                    <a href="https://answers.afrihost.com/questions/connectivity/cell+c" class="help-card">
                        <svg class="icon"><use xlink:href="#answers"></use></svg>
                        <p>Afrihost Answers</p>
                    </a>
                </div><!-- end.help-cards -->
            </div><!-- end.help-column -->
        </div><!-- end.help-tools -->
    </div>
</template>

<script>
    export default {

    }
</script>